import { clsx } from 'clsx'
import { CSSProperties } from 'react'
import { styles } from 'util/style'
import css from './Spinner.module.scss'

type Props = {
  className?: string
  size?: number
  invert?: boolean
}

export const Spinner = (props: Props) => {
  const { invert } = props
  const size = props.size ?? 25

  const className = clsx(props.className, css.container, invert && css.invert)
  const style = styles({ '--spinner-width': size.toFixed() + 'px' })

  return <div className={className} style={style as CSSProperties}>
    <svg viewBox="0 0 50 50" className={css.spinner}>
      <circle className={css.ring} cx="25" cy="25" r="22.5" />
      <circle className={css.line} cx="25" cy="25" r="22.5" />
    </svg>
  </div>
}
